<script setup lang="ts">
const runtimeConfig = useRuntimeConfig()
const route = useRoute()
useHead({
  titleTemplate: 'Jak to działa - %s',
  meta: [
    { name: 'robots', content: 'index,follow' }
  ],
  link: [
    { rel: 'canonical', href: `${runtimeConfig.public.baseUrl}${route.path}` }
  ]
})
</script>

<template>
  <div class="container mx-auto">
    <Breadcrumbs :breadcrumbs="[{ name: 'Jak to działa' }]" />
    <div class="flex xs:flex-col gap-[15px] mb-[50px]">
      <div class="w-full sm:w-1/3">
        <h3 class="bg-secondary text-20 text-white text-center p-[10px]">
          1. Wybierz i kup
        </h3>
        <p class="p-[10px]">
          By dokonać zakupu w naszym serwisie, wybierz jazdę z dostępnej oferty - kluczowa jest lokalizacja, więc zwróć uwagę na nią przed zakupem. Kliknij „dodaj do koszyka” - system sam przeprowadzi Cię przez proces zakupowy.
        </p>
      </div>
      <div class="w-full sm:w-1/3">
        <h3 class="bg-secondary text-20 text-white text-center p-[10px]">
          2. Zarezerwuj
        </h3>
        <p class="p-[10px]">
          Rezerwacji można dokonać, klikając w
          <q><NuxtLink to="/rezerwacja" class="text-primary">ZAREZERWUJ</NuxtLink></q>
          tu lub na stronie głównej. Zwróć uwagę na termin ważności vouchera - jest ważny 365 dni!
        </p>
      </div>
      <div class="w-full sm:w-1/3">
        <h3 class="bg-secondary text-20 text-white text-center p-[10px]">
          3. Zrealizuj!
        </h3>
        <p class="p-[10px]">
          Osoba obdarowana realizuje jazdę - jeżeli jest taka możliwość, możesz uczestniczyć w tym wydarzeniu - upewnij się o takiej możliwości podczas rozmowy z konsultantem.
        </p>
      </div>
    </div>
    <div class="mb-[50px]">
      <div class="text-30 text-center mb-[15px]">
        Chcesz wiedzieć więcej ?
      </div>
      <p class="text-20 text-center">
        Nasze jazdy na torach w całej Polsce rodzą często powtarzające się pytania - aby ułatwić Ci dostęp do informacji zebraliśmy kilka z nich, jeżeli dalej masz wątpliwości zadzwoń do nas 604 100 106 lub napisz korzystając z
        <NuxtLink to="/kontakt">
          formularza.
        </NuxtLink>
      </p>
    </div>
    <div class="flex xs:flex-col gap-[10px] sm:gap-[50px] mb-[15px]">
      <div class="w-full sm:w-1/3">
        <div class="flex items-center bg-primary text-16 text-white p-[15px]">
          1. Jak moge zapłacić za zamówioną jazdę?
        </div>
      </div>
      <div class="flex flex-col gap-[10px] w-full sm:w-1/2">
        <p>- przez PayU</p>
        <p>- tradycyjnym przelewem bankowym</p>
        <p>- gotówką przy odbiorze</p>
      </div>
    </div>
    <div class="flex xs:flex-col gap-[10px] sm:gap-[50px] mb-[15px]">
      <div class="w-full sm:w-1/3">
        <div class="flex items-center bg-primary text-16 text-white p-[15px]">
          2. Jak szybko otrzymam voucher?
        </div>
      </div>
      <div class="flex flex-col gap-[10px] w-full sm:w-1/2">
        <p>Czas w jakim otrzymasz voucher zależy od wybranego w zamówieniu rodzaju przesyłki.</p>
        <p>- E-voucher [PDF] - otrzymasz go na skrzynkę mailową w ciągu kilku minut od zaksięgowania wpłaty (zalecamy wybór płatności PayU kartą lub PayU Blik). Voucher elektroniczny ma postać pliku PDF w formacie A4. Możesz wydrukować go na domowej drukarce i podarować jako prezent.</p>
        <p>- Kurier DPD/Paczkomaty - zamówienia złożone od poniedziałku do piątku do godziny 12:00 (opłacone z góry lub z płatnością przy odbiorze) wysyłamy tego samego dnia roboczego.</p>
        <p>Czas dostarczenia to: Kurier 1-2 dni robocze, Paczkomaty 2-3 dni robocze</p>
        <p>- Odbiór osobisty - możesz odebrać wydrukowany voucher w Puławach na ul. 6 sierpnia 1 pokój 4a, od poniedziałku do piątku w godzinach 9-17</p>
      </div>
    </div>
    <div class="flex xs:flex-col gap-[10px] sm:gap-[50px] mb-[15px]">
      <div class="w-full sm:w-1/3">
        <div class="flex items-center bg-primary text-16 text-white p-[15px]">
          3. Jaki jest koszt dostawy voucherów?
        </div>
      </div>
      <div class="flex flex-col gap-[10px] w-full sm:w-1/2">
        <p>E-Voucher - GRATIS!</p>
        <p>Kurier DPD - przedpłata 10zł, za pobraniem - 15zł</p>
        <p>Paczkomaty InPost - przedpłata 10zł, za pobraniem - 10zł</p>
        <p>Odbiór osobisty - GRATIS!</p>
        <p>(Przy zamówieniu powyżej 200zł za przedpłatą, przesyłka gratis)</p>
      </div>
    </div>
    <div class="flex xs:flex-col gap-[10px] sm:gap-[50px] mb-[15px]">
      <div class="w-full sm:w-1/3">
        <div class="flex items-center bg-primary text-16 text-white p-[15px]">
          4.Ile mam czasu na wykorzystanie vouchera?
        </div>
      </div>
      <div class="flex flex-col gap-[10px] w-full sm:w-1/2">
        <p>Od momentu zakupu masz 12 miesięcy na wykorzystanie naszego vouchera. W przypadku jazd sezonowych jest to jeden pełny sezon na realizację.</p>
      </div>
    </div>
    <div class="flex xs:flex-col gap-[10px] sm:gap-[50px] mb-[15px]">
      <div class="w-full sm:w-1/3">
        <div class="flex items-center bg-primary text-16 text-white p-[15px]">
          5. Jak mogę zarezerwować termin jazdy?
        </div>
      </div>
      <div class="flex flex-col gap-[10px] w-full sm:w-1/2">
        <p>Jeśli posiadasz voucher i chcesz zarezerwować jazdę wejdź na: https://go-racing.pl/rezerwacja i uzupełnij formularz. W odpowiedzi na maila otrzymasz wytyczne do realizacji Twojego prezentu. Postępuj zgodnie z otrzymaną w mailu instrukcją.</p>
        <p>Jeśli na Twojej skrzynce odbiorczej nie ma maila z informacją, sprawdź pozostałe zakładki, m.in. spam, oferty, społeczności lub ponów zgłoszenie.</p>
      </div>
    </div>
    <div class="flex xs:flex-col gap-[10px] sm:gap-[50px] mb-[15px]">
      <div class="w-full sm:w-1/3">
        <div class="flex items-center bg-primary text-16 text-white p-[15px]">
          6. Czy mogę zmienić ustalony termin realizacji jazdy?
        </div>
      </div>
      <div class="flex flex-col gap-[10px] w-full sm:w-1/2">
        <p>W tym celu skontaktuj się z Wykonawcą, u którego ustalałeś/aś termin. Zmiana zarezerwowanego terminu realizacji możliwa jest nie później niż na 7 dni przed ustaloną datą realizacji lub z wyprzedzeniem określonym przy danej atrakcji, jeśli takie jest określone. W przypadku, gdy do umówionej realizacji pozostało mniej niż jest to wymagane, to decyzja o zmianie terminu leży w gestii Wykonawcy.</p>
      </div>
    </div>
    <div class="flex xs:flex-col gap-[10px] sm:gap-[50px] mb-[15px]">
      <div class="w-full sm:w-1/3">
        <div class="flex items-center bg-primary text-16 text-white p-[15px]">
          7. W jakich miesiącach odbywają się jazdy po torze?
        </div>
      </div>
      <div class="flex flex-col gap-[10px] w-full sm:w-1/2">
        <p>Jazdy po torze odbywają się w sezonie wiosenno-letnim. Terminy realizacji możesz sprawdzić w kalendarzu: https://go-racing.pl/kalendarz</p>
      </div>
    </div>
    <div class="flex xs:flex-col gap-[10px] sm:gap-[50px] mb-[15px]">
      <div class="w-full sm:w-1/3">
        <div class="flex items-center bg-primary text-16 text-white p-[15px]">
          8. Czy mogę wymienić zamówiony voucher i jak tego dokonać?
        </div>
      </div>
      <div class="flex flex-col gap-[10px] w-full sm:w-1/2">
        <p>Istnieje możliwość wymiany vouchera na inny przez 11 miesięcy od daty zakupu. Wystarczy napisać do nas wiadomość mailową na info@go-racing.pl</p>
      </div>
    </div>
    <div class="flex xs:flex-col gap-[10px] sm:gap-[50px] mb-[15px]">
      <div class="w-full sm:w-1/3">
        <div class="flex items-center bg-primary text-16 text-white p-[15px]">
          9. Czy jazda może być prezentem dla dziecka?
        </div>
      </div>
      <div class="flex flex-col gap-[10px] w-full sm:w-1/2">
        <p>W ofercie posiadamy przejazdy po torze dla dzieci jako pasażer, mini Monster Truck, jazda bolidem Formuły 1 jako pasażer.</p>
      </div>
    </div>
  </div>
</template>
